"use client";

import { Suspense, useSyncExternalStore, type ReactNode } from "react";
import { TracewayProvider } from "@tracewayapp/react";
import TracewayActivityTracker from "./TracewayActivityTracker";

const subscribeAfterHydration = (onStoreChange: () => void) => {
  const timeoutId = window.setTimeout(onStoreChange, 0);
  return () => window.clearTimeout(timeoutId);
};

const getClientHydrationSnapshot = () => true;
const getServerHydrationSnapshot = () => false;

type TracewayRootProviderProps = {
  connectionString?: string;
  appVersion?: string;
  env?: string;
  children: ReactNode;
};

export default function TracewayRootProvider({
  connectionString,
  appVersion,
  env,
  children,
}: TracewayRootProviderProps) {
  const trimmedConnectionString = connectionString?.trim();
  const isHydrated = useSyncExternalStore(
    subscribeAfterHydration,
    getClientHydrationSnapshot,
    getServerHydrationSnapshot,
  );

  if (!trimmedConnectionString || !isHydrated) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <TracewayProvider
        connectionString={trimmedConnectionString}
        options={{
          version: appVersion,
          debug: env !== "production",
          recordAllSessions: true,
          captureHttpServerErrors: true,
        }}
      >
        <Suspense fallback={null}>
          <TracewayActivityTracker />
        </Suspense>
      </TracewayProvider>
    </>
  );
}
